import styled from 'styled-components';

export const Form = styled.form`
  margin: 1rem 0 0 0;
  display: flex;
  flex-direction: column;
  width: 100%;
  flex: 1 1 auto;
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  margin: 16px 0 48px;
  gap: 16px;
`;
